import { stripHtml } from "../../helpers/stripHtml";

const initialState = {
  sumberInformasi: "",
  namaDepanPic: "",
  namaBelakangPic: "",
  emailPic: "",
  codeHpPic: "+62",
  hpPic: "",
  passwordPic: "",
  konfirmasiPasswordPic: "",
  namaPerusahaan: "",
  jenisPerusahaan: "",
  klasifikasiIndustri: "",
  klasifikasiIndustriOther: "",
  stringNpwpPerusahaan: "",
  fileNpwpPerusahaan: "",
  teleponPerusahaan: "",
  provinsiPerusahaan: "",
  kotaPerusahaan: "",
  kecamatanPerusahaan: "",
  provinsiIdPerusahaan: "",
  kotaIdPerusahaan: "",
  kecamatanIdPerusahaan: "",
  kodeposPerusahaan: "",
  patokanPerusahaan: "",
  pengirimanDokumenKeAlamatPerusahaan: false,
  salutationIndividu: "",
  namaDepanIndividu: "",
  namaBelakangIndividu: "",
  emailIndividu: "",
  codeHpIndividu: "+62",
  hpIndividu: "(+62)",
  kartuIdentitasIndividu: "",
  filekartuIdentitasIndividu: "",
  nikIndividu: "",
  pekerjaanIndividu: "",
  namaPerusahaanIndividu: "",
  jabatanIndividu: "",
  syaratKetentuan: false,
  provinsiPerusahaanPengirimanDokumen: "",
  kotaPerusahaanPengirimanDokumen: "",
  kecamatanPerusahaanPengirimanDokumen: "",
  provinsiIdPerusahaanPengirimanDokumen: "",
  kotaIdPerusahaanPengirimanDokumen: "",
  kecamatanIdPerusahaanPengirimanDokumen: "",
  kodeposPerusahaanPengirimanDokumen: "",
  patokanPerusahaanPengirimanDokumen: "",
  provinsiIndividu: "",
  kotaIndividu: "",
  kecamatanIndividu: "",
  provinsiIdIndividu: "",
  kotaIdIndividu: "",
  kecamatanIdIndividu: "",
  kodeposIndividu: "",
  patokanIndividu: "",
  dokumenRequirementLainnya: "",
  fileGLDanBuktiBayar: "",
  inputAlert: false,
  searchProgram: "",
  refCode: "",
  checkoutNow: "",
  isEarlyBird: false,
  isUsingEarlyBird: false,
  isUsingReferral: false,
  disabledRegistration: false,
};

// Password tidak di-sanitize agar karakter < dan > tetap bisa dipakai sebagai password.
const SKIP_SANITIZE_TYPES = ["SET_PASSWORD", "SET_CONFIRM_PASSWORD"];

export const inputChangeReducer = (state = initialState, rawActions) => {
  const actions =
    typeof rawActions.value === "string" && !SKIP_SANITIZE_TYPES.includes(rawActions.type)
      ? { ...rawActions, value: stripHtml(rawActions.value) }
      : rawActions;
  switch (actions.type) {
    case "SET_DISABLED_REGISTRATION":
      return {
        ...state,
        disabledRegistration: actions.value,
      };
    case "SET_USING_REFERRAL":
      return {
        ...state,
        isUsingReferral: actions.value,
      };
    case "SET_USING_EARLY_BIRD":
      return {
        ...state,
        isUsingEarlyBird: actions.value,
      };
    case "SET_EARLY_BIRD":
      return {
        ...state,
        isEarlyBird: actions.value,
      };
    case "SET_NAMA_PERUSAHAAN":
      return {
        ...state,
        namaPerusahaan: actions.value,
      };
    case "SET_JENIS_PERUSAHAAN":
      return {
        ...state,
        jenisPerusahaan: actions.value,
      };
    case "SET_KLASIFIKASI_INDUSTRI":
      return {
        ...state,
        klasifikasiIndustri: actions.value,
      };
    case "SET_KLASIFIKASI_INDUSTRI_OTHER":
      return {
        ...state,
        klasifikasiIndustriOther: actions.value,
      };
    case "SET_STRING_NPWP_PERUSAHAAN":
      return {
        ...state,
        stringNpwpPerusahaan: actions.value,
      };
    case "SET_TELEPON_PERUSAHAAN":
      return {
        ...state,
        teleponPerusahaan: actions.value,
      };
    case "SET_PROVINSI_PERUSAHAAN":
      return {
        ...state,
        provinsiPerusahaan: actions.value,
      };
    case "SET_KOTA_PERUSAHAAN":
      return {
        ...state,
        kotaPerusahaan: actions.value,
      };
    case "SET_KECAMATAN_PERUSAHAAN":
      return {
        ...state,
        kecamatanPerusahaan: actions.value,
      };
    case "SET_PROVINSI_ID_PERUSAHAAN":
      return {
        ...state,
        provinsiIdPerusahaan: actions.value,
      };
    case "SET_KOTA_ID_PERUSAHAAN":
      return {
        ...state,
        kotaIdPerusahaan: actions.value,
      };
    case "SET_KECAMATAN_ID_PERUSAHAAN":
      return {
        ...state,
        kecamatanIdPerusahaan: actions.value,
      };
    case "SET_KODEPOS_PERUSAHAAN":
      return {
        ...state,
        kodeposPerusahaan: actions.value,
      };
    case "SET_PATOKAN_PERUSAHAAN":
      return {
        ...state,
        patokanPerusahaan: actions.value,
      };
    case "SET_PENGIRIMAN_DOKUMEN_PERUSAHAAN":
      return {
        ...state,
        pengirimanDokumenKeAlamatPerusahaan: actions.value,
      };
    case "SET_SALUTATION_INDIVIDU":
      return {
        ...state,
        salutationIndividu: actions.value,
      };
    case "SET_NAMADEPAN_INDIVIDU":
      return {
        ...state,
        namaDepanIndividu: actions.value,
      };
    case "SET_NAMABELAKANG_INDIVIDU":
      return {
        ...state,
        namaBelakangIndividu: actions.value,
      };
    case "SET_EMAIL_INDIVIDU":
      return {
        ...state,
        emailIndividu: actions.value,
      };
    case "SET_CODEHP_INDIVIDU":
      return {
        ...state,
        codeHpIndividu: actions.value,
      };
    case "SET_HP_INDIVIDU":
      return {
        ...state,
        hpIndividu: actions.value,
      };
    case "SET_KIP_INDIVIDU":
      return {
        ...state,
        kartuIdentitasIndividu: actions.value,
      };
    case "SET_NIK_INDIVIDU":
      return {
        ...state,
        nikIndividu: actions.value,
      };
    case "SET_PEKERJAAN_INDIVIDU":
      return {
        ...state,
        pekerjaanIndividu: actions.value,
      };
    case "SET_NAMA_PERUSAHAAN_INDIVIDU":
      return {
        ...state,
        namaPerusahaanIndividu: actions.value,
      };
    case "SET_JABATAN_INDIVIDU":
      return {
        ...state,
        jabatanIndividu: actions.value,
      };
    case "SET_SUMBER_INFORMASI":
      return {
        ...state,
        sumberInformasi: actions.value,
      };
    case "SET_NAMADEPAN_PIC":
      return {
        ...state,
        namaDepanPic: actions.value,
      };
    case "SET_NAMABELAKANG_PIC":
      return {
        ...state,
        namaBelakangPic: actions.value,
      };
    case "SET_EMAIL_PIC":
      return {
        ...state,
        emailPic: actions.value,
      };
    case "SET_CODE_HP_PIC":
      return {
        ...state,
        codeHpPic: actions.value,
      };
    case "SET_HP_PIC":
      return {
        ...state,
        hpPic: actions.value,
      };
    case "SET_PASSWORD":
      return {
        ...state,
        passwordPic: actions.value,
      };
    case "SET_CONFIRM_PASSWORD":
      return {
        ...state,
        konfirmasiPasswordPic: actions.value,
      };
    case "SET_SYARAT_KETENTUAN":
      return {
        ...state,
        syaratKetentuan: actions.value,
      };
    case "SET_PROVINSI_PERUSAHAAN_PENGIRIMAN_DOKUMEN":
      return {
        ...state,
        provinsiPerusahaanPengirimanDokumen: actions.value,
      };
    case "SET_KOTA_PERUSAHAAN_PENGIRIMAN_DOKUMEN":
      return {
        ...state,
        kotaPerusahaanPengirimanDokumen: actions.value,
      };
    case "SET_KECAMATAN_PERUSAHAAN_PENGIRIMAN_DOKUMEN":
      return {
        ...state,
        kecamatanPerusahaanPengirimanDokumen: actions.value,
      };
    case "SET_PROVINSI_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN":
      return {
        ...state,
        provinsiIdPerusahaanPengirimanDokumen: actions.value,
      };
    case "SET_KOTA_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN":
      return {
        ...state,
        kotaIdPerusahaanPengirimanDokumen: actions.value,
      };
    case "SET_KECAMATAN_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN":
      return {
        ...state,
        kecamatanIdPerusahaanPengirimanDokumen: actions.value,
      };
    case "SET_KODEPOS_PERUSAHAAN_PENGIRIMAN_DOKUMEN":
      return {
        ...state,
        kodeposPerusahaanPengirimanDokumen: actions.value,
      };
    case "SET_PATOKAN_PERUSAHAAN_PENGIRIMAN_DOKUMEN":
      return {
        ...state,
        patokanPerusahaanPengirimanDokumen: actions.value,
      };
    case "SET_DOKUMEN_REQUIREMENT_LAINNYA":
      return {
        ...state,
        dokumenRequirementLainnya: actions.value,
      };
    case "SET_FILE_NPWP_PERUSAHAAN":
      return {
        ...state,
        fileNpwpPerusahaan: actions.value,
      };
    case "SET_FILE_KIP_INDIVIDU":
      return {
        ...state,
        filekartuIdentitasIndividu: actions.value,
      };
    case "SET_FILE_GL_DAN_BUKTI_BAYAR":
      return {
        ...state,
        fileGLDanBuktiBayar: actions.value,
      };
    case "SET_INPUT_ALERT":
      return {
        ...state,
        inputAlert: actions.value,
      };
    case "SET_SEARCH_PROGRAM":
      return {
        ...state,
        searchProgram: actions.value,
      };
    case "SET_PROVINSI_INDIVIDU":
      return {
        ...state,
        provinsiIndividu: actions.value,
      };
    case "SET_KOTA_INDIVIDU":
      return {
        ...state,
        kotaIndividu: actions.value,
      };
    case "SET_KECAMATAN_INDIVIDU":
      return {
        ...state,
        kecamatanIndividu: actions.value,
      };
    case "SET_PROVINSI_ID_INDIVIDU":
      return {
        ...state,
        provinsiIdIndividu: actions.value,
      };
    case "SET_KOTA_ID_INDIVIDU":
      return {
        ...state,
        kotaIdIndividu: actions.value,
      };
    case "SET_KECAMATAN_ID_INDIVIDU":
      return {
        ...state,
        kecamatanIdIndividu: actions.value,
      };
    case "SET_KODEPOS_INDIVIDU":
      return {
        ...state,
        kodeposIndividu: actions.value,
      };
    case "SET_PATOKAN_INDIVIDU":
      return {
        ...state,
        patokanIndividu: actions.value,
      };
    case "SET_REF_CODE":
      return {
        ...state,
        refCode: actions.value,
      };
    case "SET_CHECK_OUT_NOW":
      return {
        ...state,
        checkoutNow: actions.value,
      };
    default:
      return {
        ...state,
      };
  }
};
